import { useState, useContext, useEffect } from 'react';
import api from './api/axiosInstance';
import { UserContext } from './UserContext';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Sidebar from './Sidebar.js';
import { Card, Row, Col, Container, Alert, Modal, Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import TicketAddDetails from './TicketAddDetails';
import { TicketCountContext } from './TicketCountContext';
import Breadcrumb from './Breadcrumb.js';
import { isAdminType} from './utils/roleUtils';
import icSucess from './assets/img/ic-celebration-circle.svg';

const TicketAdd = () => {
    const { user } = useContext(UserContext);
    const { ticketCount, refreshTicketCount } = useContext(TicketCountContext);
    const navigate = useNavigate();
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [formData, setFormData] = useState({
        priority: '',
        ticketClass: '',
        status: '',
        owner: '',
        businessPurpose: '',
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
    
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const hasErrors = (obj) =>
        Object.values(obj ?? {}).some(v =>
            v && (typeof v === 'string'
            ? v.trim() !== ''
            : Array.isArray(v)
                ? v.length > 0 || v.some(hasErrors)
                : typeof v === 'object'
                ? hasErrors(v)
                : Boolean(v))
        );

        useEffect(() => {
            setShowErrorMessage(hasErrors(errors));
    }, [errors]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            priority: formData.priority || '',
            ticketClass: formData.ticketClass || '',
            status: formData.status || '',
            owner: formData.owner || '',
            businessPurpose: formData.businessPurpose || '',
            createdBy: user?._id
        };

        const newErrors = {};

        if (!formData.priority) newErrors.priority = 'Priority is required';
        if (!formData.ticketClass) newErrors.ticketClass = 'Class is required';
        if (!formData.status) newErrors.status = 'Status is required';
        if (!formData.owner) newErrors.owner = 'Ticket Owner is required';

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return;

        try {
            console.log('Sending data:', payload);
            const response = await api.post(`/api/tickets`, payload);
            console.log('Ticket Created:', response.data);
            setShowSuccessModal(true);
        } catch (error) {
            console.error('Error creating ticket:', error);
            setErrors((prevErrors) => ({
                ...prevErrors,
                general: error.response?.data?.message || 'An error occurred while creating the ticket. Please try again.',
            }));
        }
    };

    if (!user || !isAdminType(user.role)) {
        return <div>You are not authorized to view this page.</div>;
    }
    
    return (
        <>
            <Sidebar ticketCount={ticketCount} />
            <main className="main-content flex-grow-1">
                <Container>
                    <Row>
                        <Col>
                            {showErrorMessage && (
                                <Alert variant="danger" onClose={() => setShowErrorMessage(false)} dismissible>
                                    <p><strong>Error</strong> - There are items that require your attention</p>
                                </Alert>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Breadcrumb />
                        </Col>
                    </Row>
                    <Row>
                        {/* Main Content */}
                        <Col xs={12}>
                            <Card>
                                <Card.Body>
                                    <Row>
                                        <Col>
                                            <h1>Add Ticket</h1>
                                        </Col>
                                    </Row>
                                    <Form onSubmit={handleSubmit}>
                                        <>  
                                            <Row>
                                                <Col md={12}>
                                                    <TicketAddDetails
                                                        formData={formData}
                                                        handleChange={handleChange}
                                                        errors={errors}
                                                    />
                                                </Col>
                                            </Row>
                                        </>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row className="buttons-row">
                        <Col>
                            <Button variant="outline-secondary" onClick={() => navigate('/ticket-list')}>
                                Cancel
                            </Button>
                            <Button variant="primary" onClick={handleSubmit}>Finish</Button>
                        </Col>
                    </Row>
                </Container>
            </main>
                                    
            {/* Success Modal */}

            <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
                <Modal.Header closeButton onClick={() => navigate('/ticket-list')}>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Image
                        src={icSucess}
                        alt=""
                        className="d-block m-auto mb-4"
                    />
                    <h2 className="text-center mb-3">Congratulations</h2>
                    <p className="text-center">You have successfully added a new ticket to aBROADIFY.</p>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center">
                    <Button variant="primary" onClick={() => navigate('/ticket-list')}>
                        Go to Tickets
                    </Button>
                </Modal.Footer>
            </Modal>;
        </>
    );
};

export default TicketAdd;
